import { useFieldArray } from 'react-hook-form';

export function useTripFieldArray() {
  return useFieldArray({
    name: 'trips',
    rules: { minLength: 1 },
  });
}
